import React from "react";
import "./BankingSlide.css";
import FeaturedCompainesLogo from '../../assets/icons/FeaturedCompainesLogo.svg';
import buildingLogo from '../../assets/images/icici.png';
import buildingLogo1 from '../../assets/images/yes.png';
import buildingLogo2 from '../../assets/images/axis.png';
import buildingLogo3 from '../../assets/images/auxilo.png';
import buildingLogo4 from '../../assets/images/avanse.png';
import BankLogo from '../../assets/icons/bankLogo.svg'

export default function BankingSlide() {
  // Creating an array of 5 items to map over
  const companies = [{1:1, img: buildingLogo}, {2:2, img: buildingLogo1}, {3:3, img: buildingLogo2}, {4:4, img: buildingLogo3}, {5:5, img: buildingLogo4}];

  return (
    <div className="featured-container">
      {/* Title Section */}
      <div className="title-section">
        <img src={BankLogo} alt="logo"></img>
        <h2 className="title-text">
          Banking <span>Partners</span>
        </h2>
        <div className="underline"></div>
      </div>

      {/* Logo Section */}
      <div className="scroll-wrapper">
        <div className="scroll-track">
          {[...companies, ...companies].map((item, index) => (
            <div key={index} className="logo-card">
              <img src={item.img} alt="logo" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
